
























import { Component, Vue, Prop } from "vue-property-decorator"
import Swiper from 'swiper'

@Component({

})
export default class ImageSlider extends Vue {
  public $refs!: {
    container: HTMLElement
  }
  public count: number = 0
  public index: number = 0
  public slider!: Swiper
  
  @Prop(Array) images!: string[]

  public go (index: number) {
    this.slider.slideTo(index)
  }

  public getPaginationClass (index: number) {
    return {
      'is-active': this.index === index
    }
  }

  async mounted () {
    Vue.nextTick(() => {
      const slider = new Swiper(this.$refs.container, {
        on: {
          init: () => {
            setTimeout(() => {
               this.count = slider.slides.length
              this.index = slider.realIndex
            }, 200)
            // this.count = slider.slides.length
            // this.index = slider.realIndex
            // console.log(this)
          },
          slideChange: () => {
            this.count = slider.slides.length
            this.index = slider.realIndex
          },
          lazyImageReady: () => {
            slider.update()
          }
        },
        autoHeight: true,
        watchOverflow: true,
        preloadImages: false,
        pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
    // Enable lazy loading
    // lazy: true,
    lazy: {
    loadPrevNext: false,
    preloaderClass: 'slider-preloader'
  }
      })

      this.slider = slider
    })

    
    
  }
}
